import React from 'react';
import { Link } from 'react-router-dom';
import './CookieBanner.css';

const CookieBanner = ({ onAcceptAll, onRejectAll, onCustomize }) => {
  return (
    <div className="cookie-banner">
      <div className="cookie-banner-content">
        <div className="cookie-banner-text">
          <h3>🍪 We Value Your Privacy</h3>
          <p>
            We use cookies and similar technologies to enhance your browsing experience, analyze site traffic, and personalize content. By clicking "Accept All", you consent to our use of cookies.
          </p>
          <div className="cookie-banner-links">
            <Link to="/cookie-policy">Cookie Policy</Link>
            <span>•</span>
            <Link to="/privacy">Privacy Policy</Link>
          </div>
        </div>
        
        <div className="cookie-banner-actions">
          <button 
            className="btn btn-ghost" 
            onClick={onRejectAll}
            aria-label="Reject all non-essential cookies"
          >
            Reject All
          </button>
          <button 
            className="btn btn-secondary" 
            onClick={onCustomize}
            aria-label="Customize cookie preferences"
          >
            Customize
          </button>
          <button 
            className="btn btn-primary" 
            onClick={onAcceptAll}
            aria-label="Accept all cookies"
          >
            Accept All
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieBanner;
